import { ChangeDetectionStrategy, Component } from '@angular/core';
import { OrganizationProfile } from 'app/organization/model/organization-profile';
import { ClientSystemLinksService } from 'app/organization/client-system-links.service';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { IAppConfig } from 'app/app-config';
import { ClientSystemLink } from 'app/organization/model/client-system-link';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { ApiImageSrcDirective } from '@customer-apps/api-image/api-image-src.directive';
import { ClientSystemLinkComponent } from '../client-system-link/client-system-link.component';
import { SvgIconDirective } from '@styleguide/svg-icon/svg-icon.directive';
import { IfModuleEnabledDirective } from '@customer-apps/enabled-modules/if-module-enabled.directive';
import { OrganizationService } from '@customer-apps/organization/organization.service';
import { UserCredentialsStore } from '@customer-apps/user/user-credentials-store.service';
import { ConfigService } from '@customer-apps/config/config.service';
import { AppStateService } from '@customer-apps/app-state/app-state.service';

@Component({
  selector: 'kgr-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    ApiImageSrcDirective,
    ClientSystemLinkComponent,
    RouterLinkActive,
    SvgIconDirective,
    IfModuleEnabledDirective,
    AsyncPipe,
  ],
})
export class MainMenuComponent {
  organization$ = this.organizationService.organization$;

  clientSystemLinks$: Observable<ClientSystemLink[]> = this.userCredentialsStore.userCredentials$.pipe(
    switchMap((userCredentials) => {
      if (userCredentials) {
        return this.clientSystemLinksService.getAuthenticatedClientSystemLinks();
      } else {
        return of([]);
      }
    }),
  );

  privacyUrl = this.configService.config.privacyUrl;
  staticLogo = this.configService.config.staticLogo;
  clientLogoFileName = this.configService.config.clientLogoInMenuFileName || this.configService.config.clientLogoFileName;

  isScreenMediumAndUp$ = this.appStateService.isScreenMediumAndUp$;

  constructor(
    private organizationService: OrganizationService<OrganizationProfile>,
    private userCredentialsStore: UserCredentialsStore,
    private clientSystemLinksService: ClientSystemLinksService,
    private configService: ConfigService<IAppConfig>,
    private appStateService: AppStateService,
  ) {}
}
